;
define("product_details_quantity.tpl", function(){});

